import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useGetDocumentHistoryById } from "../hooks/api";
import { useUpdateCustomerData } from "../hooks/ui";
import { Anchor, Box, Divider, Flex, Paper, Text, Title } from "@mantine/core";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import { isFullCredentials } from "../hooks/ui/customerDataStore";
import ErrorComponent from "../components/errorComponent";
import { LoaderComponent } from "../components/loaderComponent";

export const Route = createFileRoute("/my-documents")({
  component: RouteComponent,
});

function RouteComponent() {
  const { customerData } = useUpdateCustomerData();
  const { data, isSuccess, isError, isLoading } = useGetDocumentHistoryById({
    credentials: customerData.credentials,
    enabled: isFullCredentials(customerData.credentials),
  });
  const router = useRouter();

  if (isLoading) {
    return <LoaderComponent />;
  }
  if (isError) {
    return <ErrorComponent />;
  }

  if (isSuccess)
    if (data.length === 0)
      return (
        <>
          <Anchor
            component="button"
            onClick={() => router.history.back()}
            style={{ cursor: "pointer" }}
            c="var(--wallet-color-neutrals-black)"
            mt={"xl"}
          >
            ← Tillbaka
          </Anchor>
          <Title
            order={1}
            size="h3"
            ff={"var(--wallet-font-family-sambla-sans)"}
            mb={"md"}
            mt={"xl"}
          >
            Dina dokument
          </Title>
          <Text mb={"md"}>
            Här kan du hitta alla dokument som är kopplade till ditt ärende.
            Vänligen kontakta oss om du har några frågor.
          </Text>
          <Paper shadow="xs" radius="md" p="xl" mt={"xl"}>
            <Text ta={"center"}>Ingen dokument att visa</Text>
          </Paper>
        </>
      );
  return (
    <>
      <Anchor
        component="button"
        onClick={() => router.history.back()}
        style={{ cursor: "pointer" }}
        c="var(--wallet-color-neutrals-black)"
        mt={"xl"}
      >
        ← Tillbaka
      </Anchor>
      <Title
        order={1}
        size="h3"
        ff={"var(--wallet-font-family-sambla-sans)"}
        mb={"md"}
        mt={"xl"}
      >
        Dina dokument
      </Title>
      <Text mb={"md"}>
        Här kan du hitta alla dokument som är kopplade till ditt ärende.
        Vänligen kontakta oss om du har några frågor.
      </Text>
      <Paper radius="lg" p="xl" mt={"xl"}>
        <Box
          component="ul"
          role="list"
          style={{ listStyle: "none", margin: 0, padding: 0 }}
        >
          {data?.map((element) => {
            const dateMatch = element.fileName.match(/-(\d{4}-\d{2}-\d{2})_/);
            const extractedDate = dateMatch ? dateMatch[1] : "Unknown date";
            const truncatedFileName = element.fileName.split("-")[0];
            return (
              <Box
                component="li"
                key={element.sortKey}
                id={element.sortKey}
                mb={"sm"}
              >
                <Text c="dimmed" mb={"xs"}>
                  {extractedDate}
                </Text>
                <Flex
                  justify={"space-between"}
                  align={{ base: "flex-start", sm: "center" }}
                  direction={{ base: "column", xs: "row" }}
                  gap={{ base: "xs", sm: 0 }}
                >
                  <Text fw={700}>
                    {truncatedFileName === "sambla"
                      ? "Rådgivningsdokument"
                      : "Flyttdokument"}
                  </Text>
                  <Anchor href={element.url} display={"flex"}>
                    Se dokument
                    <ArrowTopRightOnSquareIcon
                      width={"16px"}
                      style={{ marginLeft: "10px" }}
                    />
                  </Anchor>
                </Flex>
                <Divider my="md" />
              </Box>
            );
          })}
        </Box>
      </Paper>
    </>
  );
}
